define('modules/auth/auth.module',["client"],
    function(Prospector){
        Prospector.module("AuthApp", function(AuthApp, Prospector, Backbone, Marionette, $, _){
            AuthApp.startWithParent = false;

            AuthApp.onStart = function(){
                window.utils.rawOutput("starting AuthApp");
            };

            AuthApp.onStop = function(){
                window.utils.rawOutput("stopping AuthApp");
            };
        });

        Prospector.module("Routers.AuthApp", function(AuthAppRouter, Prospector, Backbone, Marionette, $, _){
            AuthAppRouter.Router = Marionette.AppRouter.extend({
                appRoutes: {
                    "auth"     : "auth",
                    "login"    : "login",
                    "reset"    : "reset",
                    "signup"   : "signup"
                }
            });

            var executeAction = function(action, arg){
                Prospector.startSubApp("AuthApp");
                action(arg);
            };

            var API = {
                auth: function(criterion){
                    var passedFunc = function(){
                        require(["modules/auth/forms/auth.controller"], function(FormsController){
                            executeAction(FormsController.loadAuth, criterion);
                        });
                    };
                    Prospector.trigger("ValidateSession", {
                        passedFunc: passedFunc
                    })
                },
                login: function(criterion){
                    var passedFunc = function(){
                        require(["modules/auth/forms/auth.controller"], function(FormsController){
                            executeAction(FormsController.loadLogin, criterion);
                        });
                    };
                    Prospector.trigger("ValidateSession", {
                        passedFunc: passedFunc
                    });
                },
                reset:function(criterion){
                    var passedFunc = function(){
                        require(["modules/auth/reset/reset.controller"], function(ResetController){
                            executeAction(ResetController.loadReset, criterion);
                        });
                    };
                    Prospector.trigger("ValidateSession", {
                        passedFunc: passedFunc
                    });
                },
                signup:function(criterion){
                    var passedFunc = function(){
                        require(["modules/auth/signup/signup.controller"], function(ResetController){
                            executeAction(ResetController.loadSignUp, criterion);
                        });
                    };
                    Prospector.trigger("ValidateSession", {
                        passedFunc: passedFunc
                    });
                },
            };
            Prospector.on("auth", function(){
                API.auth();
            });

            Prospector.on("ValidateSession", function(options){
                var userToken = window.utils.readCookie("userToken");
                if(userToken != null) {
                    window.session.fetch({
                        success: function () {
                            if (window.session.has('status') && window.session.get('status') == 100) {
                                var cookieHost = window.utils.readCookie("specifiedHost");
                                window.location.href = window.location.protocol + "//" +cookieHost;
                            } else {
                                options.passedFunc();
                            }
                        },
                        error:function(){
                            options.passedFunc();
                        }
                    });
                } else {
                    options.passedFunc();
                }
            });
            Prospector.addInitializer(function(){
                new AuthAppRouter.Router({
                    controller: API
                });
            });
        });

        return Prospector.AuthAppRouter;
    });
